import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Accordion } from '@/components/layouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const SecuritiesPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Securities Report"
        subTitleText="有価証券報告書"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Accordion
        id="irp-library-category"
        className="irp-library-category irp-library-category-3"
      />
    </Layout>
  )
}

SecuritiesPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'IRライブラリー', path: '/ir/library' },
    { name: '有価証券報告書', path: '' },
  ]

  return (
    <>
      <Head
        title="有価証券報告書"
        description="トライアルホールディングスの四半期報告書及び有価証券報告書について掲載しています。"
        ogp={{ url: 'ir/library/securities/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
